/* eslint-disable no-useless-concat */
export const APP_ROOT_PROTOCOL = window.location.protocol;
export const APP_ROOT_HOSTNAME = window.location.hostname;
export const APP_ROOT_PORT = window.location.port;
export const APP_ROOT_DEV = "https://localhost:5001";
export const APP_ROOT_PROD = APP_ROOT_PROTOCOL + "//" + APP_ROOT_HOSTNAME + ":" + APP_ROOT_PORT;
export const APP_ROOT = process.env.NODE_ENV === "development" ? APP_ROOT_DEV : APP_ROOT_PROD;
export const IS_DEVELOPMENT_MODE = process.env.NODE_ENV === "development" ? true : false;

export const INTERVAL = {
  ALERT_TIMEOUT: 5000,
};

export const FILE_NAME_VALIDATION = {
  MAX_CHAR_NAME: 50,
  INVALID_CHAR_REGEX: /^[^<>:;,?"*|/\\]+$/,
};
